module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isHcpView) ? _c('hcp-downloads') : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('patient-downloads') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2a396f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Downloads/Downloads.vue
// module id = 3597
// module chunks = 1